





import Vue from "vue";
import { Component, Provide } from "vue-property-decorator";
import { ContactService } from "../../services/ContactService";
import { GenericService } from "../../services/GenericService";

@Component({})
export default class Records extends Vue {
  @Provide()
  contactService = new ContactService(
    this.$store.getters["customer/customerMbeId"]
  );

  @Provide()
  genericService = new GenericService();
}
